export default __webpack_public_path__ + "static/media/Matsal7.af41be80.jpeg";